<template>
  <div class="slider" :class="{ in_page_slidehow: in_page_slidehow }">
    <div class="close" @click="$parent.show_images = false">
      <img src="@/assets/img/close.svg" />
      <p>close</p>
    </div>
    <div class="controls">
      <img
        class="flip left"
        @click="navigate(-1)"
        src="@/assets/img/next.svg"
      />
      <img class="right" @click="navigate(1)" src="@/assets/img/next.svg" />
    </div>
    <div class="offclick" @click="$parent.show_images = false"></div>
    <carousel
      :perPage="1"
      :loop="true"
      navigationNextLabel=">"
      :navigateTo="current_index"
      :autoplay="in_page_slidehow ? true : false"
      :autoplayTimeout="6000"
    >
      <slide v-for="(item, i) in slides">
        <div
          v-if="(item.type && item.type.includes('image')) || !item.type"
          class="image"
          :style="{ backgroundImage: 'url(' + item.url + ')' }"
        >
          <template v-if="show_text">
            <div class="dark"></div>
            <div class="text">
              <p class="timeline">{{ item.sub_title }}</p>
              <p class="headline">{{ item.headline }}</p>
              <p class="subhead">{{ item.description }}</p>
            </div>
          </template>
        </div>
        <div v-if="item.type && item.type.includes('video')" class="image">
          <video loop autoplay muted :src="item.url"></video>
          <template v-if="show_text">
            <div class="dark"></div>
            <div class="text">
              <p class="timeline">{{ item.sub_title }}</p>
              <p class="headline">{{ item.headline }}</p>
              <p class="subhead">{{ item.description }}</p>
            </div>
          </template>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "slider",
  props: ["slides", "in_page_slidehow", "show_text"],
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      current_index: 0,
    };
  },
  methods: {
    navigate(direction) {
      if (this.current_index == this.slides.length && direction == 1) {
        this.current_index = 0;
      } else if (this.current_index == 0 && direction == -1) {
        this.current_index = this.slides.length - 1;
      } else {
        this.current_index = this.current_index + direction;
      }
    },
  },
};
</script>

<style lang="scss">
.slider {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .offclick {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .VueCarousel {
    width: 1600px;
    height: 800px;
    .VueCarousel-pagination {
      display: none !important;
    }
  }
  .controls {
    img {
      position: absolute;
      filter: brightness(0) invert(1);
      z-index: 10;
      left: 30px;
      height: 100px;
      opacity: 0.3;
      padding: 20px;
      box-sizing: border-box;
      margin-top: -20px;
      &.flip {
        transform: scaleX(-1);
      }
      &.right {
        left: auto;
        right: 30px;
      }
    }
  }
  .image {
    width: 1600px;
    height: 800px;
    position: relative;
    background-size: cover;
    video {
      width: 100%;
    }
    .dark {
      background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
      height: 600px;
      width: 100%;
      position: absolute;
      bottom: 0;
    }
    .text {
      position: absolute;
      padding: 100px;
      padding-bottom: 75px;
      color: white;
      z-index: 2;
      bottom: 0;
      width: 100%;
      max-width: 1000px;
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &.headline {
          font-size: 50px;
          font-weight: bold;
          text-transform: uppercase;
          margin-bottom: 40px;
        }
        &.timeline {
          margin-bottom: 5px;
          font-size: 20px;
          font-weight: 500;
          text-transform: uppercase;
          opacity: 0.7;
        }
      }
    }
  }
  &.in_page_slidehow {
    position: relative;
    width: 100%;
    height: 600px;
    margin-top: 50px;
    background: transparent;
    align-items: flex-start;
    .controls {
      img {
        position: absolute;
        top: 45%;
        opacity: 0.6;
        &.flip {
          transform: scaleX(-1);
          left: 0;
        }
        &.right {
          left: auto;
          right: 0;
        }
      }
    }
    .offclick,
    .close {
      display: none;
    }
    .VueCarousel {
      width: 100%;
      height: 600px;
      .image {
        width: 100%;
        height: 600px;
        background-size: cover;
      }
    }
  }
}
</style>
